import _ from 'lodash';
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext';
import { useContext, useMemo } from 'react';
import { MatchContentWithProvider } from './MatchContent';

const _labelSize = 'tiny'

export const MatchesDate = ({
  dateKey,
  levelKey,
  matchDisplayType,
  // matches,
  matchScheduleDisplayType,
  parentKey,
  sectionKey,
  teamKey,
}) => {

  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state } = sportsSeasonContext ?? {};
  const { matches_info, seasonMatches_info } = sportsSeason_state ?? {};
  const _matches_info = matches_info;
  const { matches_groupInfo } = _matches_info ?? {};
  const { levelKeys, levelLatestStartDates, scheduleLevelKeys: _scheduleLevelKeys, levelSectionDateMatches: _levelSectionDateMatches } = matches_groupInfo ?? {};

  const lsdms = _levelSectionDateMatches?.[levelKey]?.[dateKey]?.[sectionKey]

  const dateMatches = useMemo(() => {
    if (!lsdms) return;
    return _.map(lsdms, (match) => (
      // <div>{`ss ${dateKey}-${levelKey}-${sectionKey}-${match?._itemKey}`}</div>
      <MatchContentWithProvider
        dateKey={dateKey}
        levelKey={levelKey}
        sectionKey={sectionKey}
        key={match._itemKey}
        matchKey={match._itemKey}
        match={match}
        matchDisplayType={matchDisplayType}
        parentKey={parentKey}
        teamKey={teamKey}
        matchScheduleDisplayType={matchScheduleDisplayType}
        favTeamKey={match._favTeamKey} // 👈 pass it down if needed
      />
    ));
  })

  return dateMatches

}

